import * as React from 'react';
export const IcNightMostlyClear = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.49 18.07V18a2.5 2.5 0 00-4.58-1.39c-.21-.07-.44-.11-.67-.11-1.24 0-2.25 1.01-2.25 2.25 0 .09.02.17.03.25h-.03c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h7c1.1 0 2-.9 2-2 0-.93-.64-1.71-1.51-1.93h.01zm-5.32-3.57c.79-.64 1.78-1 2.83-1 .91 0 1.75.28 2.46.75.28-.8.46-1.65.52-2.52a9.976 9.976 0 00-5.48-9.61c-.87-.44-1.79.47-1.35 1.34.71 1.41 1.02 3.05.76 4.79-.5 3.43-3.28 6.2-6.7 6.7-1.74.26-3.38-.05-4.79-.76-.87-.44-1.77.49-1.34 1.35a9.995 9.995 0 007.46 5.39c-.02-.14-.04-.28-.04-.42 0-1.27.68-2.38 1.69-2.99a4.26 4.26 0 013.99-3.01l-.01-.01z'
      fill='currentColor'
    />
  </svg>
);
